import { Inject, injectable } from 'inversify-props';
import { BaseAPIService } from './base-api.service';
import { PaymentRequestBuilder } from '@/models/DTO/payments/payment-request-builder.model';
import { PaymentRequest } from '@/models/DTO/payments/payment-request.model';
import { VerifyPaymentRequestModel } from '@/models/DTO/payments/verify-payment-request.model';
import { VerifyPaymentResponse } from '@/models/DTO/payments/verify-payment-response.model';

const API_VERSION: string = process.env.VUE_APP_API_VERSION;
const PAYMENTS_STUB_URL = `/api/v${API_VERSION}/Payments`;
const CREATE_PAYMENT_REQUEST_OBJECT_URL = `${PAYMENTS_STUB_URL}/CreatePaymentRequestObject`;
const VERIFY_PAYMENT_RESPONSE_URL = `${PAYMENTS_STUB_URL}/VerifyPaymentResponse`;

export interface PaymentsService {
  createPaymentRequestObject(
    model: PaymentRequestBuilder
  ): Promise<PaymentRequest>;

  verifyPaymentResponse(
    model: VerifyPaymentRequestModel
  ): Promise<VerifyPaymentResponse>;
}

@injectable()
export class PaymentsService implements PaymentsService {
  @Inject()
  private readonly _baseAPIService!: BaseAPIService;

  public async createPaymentRequestObject(
    model: PaymentRequestBuilder
  ): Promise<PaymentRequest> {
    const resp = await this._baseAPIService.client.post<PaymentRequest>(
      CREATE_PAYMENT_REQUEST_OBJECT_URL,
      {
        ...model
      }
    );

    return resp.data;
  }

  public async verifyPaymentResponse(
    model: VerifyPaymentRequestModel
  ): Promise<VerifyPaymentResponse> {
    const resp = await this._baseAPIService.client.post<VerifyPaymentResponse>(
      VERIFY_PAYMENT_RESPONSE_URL,
      {
        ...model
      }
    );

    return resp.data;
  }
}
